import * as React from "react";
const SvgBriefcase = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 17,
	height: 15,
	viewBox: "0 0 17 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M15 2.5H11.875V1.875C11.875 1.37772 11.6775 0.900806 11.3258 0.549175C10.9742 0.197544 10.4973 0 10 0H6.25C5.75272 0 5.27581 0.197544 4.92417 0.549175C4.57254 0.900806 4.375 1.37772 4.375 1.875V2.5H1.25C0.918479 2.5 0.600537 2.6317 0.366116 2.86612C0.131696 3.10054 0 3.41848 0 3.75V13.75C0 14.0815 0.131696 14.3995 0.366116 14.6339C0.600537 14.8683 0.918479 15 1.25 15H15C15.3315 15 15.6495 14.8683 15.8839 14.6339C16.1183 14.3995 16.25 14.0815 16.25 13.75V3.75C16.25 3.41848 16.1183 3.10054 15.8839 2.86612C15.6495 2.6317 15.3315 2.5 15 2.5ZM5.625 1.875C5.625 1.70924 5.69085 1.55027 5.80806 1.43306C5.92527 1.31585 6.08424 1.25 6.25 1.25H10C10.1658 1.25 10.3247 1.31585 10.4419 1.43306C10.5592 1.55027 10.625 1.70924 10.625 1.875V2.5H5.625V1.875ZM15 3.75V9.375H1.25V3.75H15Z",
	fill: "#F35900"
}));
export default SvgBriefcase;
